<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <div class="mb-5">
          <label class="label-input">Gradient Text</label>
          <div class="group-item">
            <label>Text</label>
            <v-text-field v-model="fields.text" hide-details class="mt-0 mb-3" />
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  label="From Color"
                  :value="fields.fromColor"
                  name="cefloreco-text-gradient-from-color"
                  default-color="#eeeeee"
                  @input="value => (fields.fromColor = value)"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  label="To Color"
                  :value="fields.toColor"
                  name="cefloreco-text-gradient-to-color"
                  default-color="#333333"
                  @input="value => (fields.toColor = value)"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Description</label>
          <div class="group-item">
            <v-text-field v-model="fields.description" hide-details class="mt-0" />
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import { updateHtmlFromData } from '../common/html/update';
import ColorPicker from '../common/ui-modules/inputs/color-picker.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';

const getDefaultFields = () => ({
  title: 'Cefloreco Text Gradient Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#000000',
    textColor: '#FFFFFF',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: true,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  text: '130M+',
  fromColor: '#eeeeee',
  toColor: '#333333',
  description: 'Monthly Active Users',
});

export default {
  name: 'CeflorecoTextGradientSectionEditor',
  components: { SectionLayout, ColorPicker },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});

    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCeflorecoTextGradient(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline,
.ck-editor__editable {
  min-height: 140px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
